<template>
  <div class="body">
    <div class="AmountRecycling">
      <div class="AmountRecycling-tops">
        <div class="AmountRecycling-num AmountRecycling-num-speace">
          <div class="AmountRecycling-nums">{{RecyclingName}}</div>
          <div class="AmountRecycling-nums-style">
            <chart-num
              :scrollNum="AmountOfRecycling"
            />
          </div>
        </div>
        <div class="AmountRecycling-num">
          <div class="AmountRecycling-nums">{{ RecoveryName }}</div>
          <div class="AmountRecycling-nums-style">
            <chart-num
              :scrollNum="AmountOfRecovery"
            />
          </div>
        </div>
      </div>
    </div>
    <div id="map">
      <echart-map />
    </div>
  </div>
</template>

<script>
import { MaplibreGLMap } from '@/plugins/mapjs/mapConfig';
import EchartMap from '@/components/echartsMenu/echarts.vue';
import chartNum from '@/views/IndustryMap/components/chartNum.vue';
export default {
  name: 'resourceMap',
  data() {
    return {
      AmountOfRecycling: 0,
      AmountOfRecovery: 0,
      RecyclingName:'回收总量（万吨）',
      RecoveryName:'回收金额（亿元）'
    };
  },
  components: {
    EchartMap,
    chartNum,
  },
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    resourceData: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  watch: {
    mapData:{
      handler:function (val){
        this.RecyclingName = '回收总量（万吨）'
        this.RecoveryName = '回收金额（亿元）'
        this.AmountOfRecycling = val?.provinceProduction || 0
        this.AmountOfRecovery = val?.provinceValue || 0
      }
    },
    resourceData:{
      handler:function (val){
        console.log('resourceDataresourceData',val)
        this.RecyclingName = '资源交易量（万吨）'
        this.RecoveryName = '资源销售额（万元）'
        if(val && val.length) {
          val?.forEach(item=>{
            if(item.type == 10218){
              this.AmountOfRecycling = (item.amount / 10000).toFixed(3)
            }else if(item.type == 10219){
              this.AmountOfRecovery = (item.amount / 10000).toFixed(3)
            }
          })
        }else {
          this.AmountOfRecycling = 0
          this.AmountOfRecovery = 0
        }
      }
    }
  },
  methods: {
    initMap() {
      const config = {
        container: 'map',
        style: {
          version: 8,
          sources: {},
          layers: [],
          sprite:
            'https://10.28.136.206:30011/mapbox/static/sprites/streets/sprite',
          glyphs:
            'https://10.28.136.206:30011/mapbox/api/fonts/{fontstack}/{range}.pbf',
        }, // 完全空白的样式
        center: [104, 30.9], // 初始中心点
        zoom: 1, // 初始缩放级别
      };
      const map = new MaplibreGLMap(config);
    },
  },
};
</script>

<style scoped lang="less">
.body {
  height: inherit;
  width: inherit;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .AmountRecycling {
    width: 875px;
    height: 106px;
    .AmountRecycling-tops {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .AmountRecycling-num {
        color: #ffffff;
        font-size: 18px;
        .AmountRecycling-nums {
          display: flex;
          font-weight: 700;
          justify-content: center;
        }
        .AmountRecycling-nums,
        .AmountRecycling-numss {
          display: flex;
          align-items: center;
        }
        .AmountRecycling-nums-style {
          margin-top: 20px;
        }
      }
      .AmountRecycling-num-speace {
        margin-right: 40px;
      }
      .AmountRecycling-num-unit {
        background: url('~@/assets/recycling/echartsMap/numBackgrounds.svg')
          no-repeat;
        background-size: cover;
        width: 50px;
        height: 60px;
        font-weight: 700;
        margin-right: 12px;
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  #map {
    width: 100%;
    height: calc(100% - 126px);
    /deep/.maplibregl-ctrl-bottom-right {
      display: none !important;
    }
  }
}
</style>
